export default __webpack_public_path__ + "images/BM.1c94fef.png";